import PropTypes from 'prop-types';
import React from 'react';

export const i18nContextPropType = PropTypes.shape({
  lang: PropTypes.string,
  locale: PropTypes.object
});

const undef = {
  report(str, lang = '') {
    const unique = `${lang}-${str}`;
    if (this.uniques.indexOf(unique) === -1) {
      this.uniques.push(unique);
      if (this.cb) {
        this.cb(str, lang);
      }
    }
  },
  uniques: []
};

export function onUndefined(fn) {
  if (typeof fn === 'function') {
    undef.cb = fn;
  }
}

function get(str, locale, lang) {
  if (!locale) {
    return str;
  }

  const localized = locale.get(str);

  if (localized === undefined) {
    undef.report(str, lang);
  }

  return localized || str;
}

function i18n() {
  return function translate(str, ...args) {
    const { locale = null, lang } =
      (this.context && this.context.i18n && this.context.i18n) || {};
    const localized = get(str, locale, lang);

    if (args.length) {
      if (/%r/.test(localized)) {
        const children = localized.split('%r');

        return React.Children.map(
          children.reduce((acc, substr, idx) => {
            if (idx) {
              acc.push(args[idx - 1]);
            }
            acc.push(substr);
            return acc;
          }, []),
          c => c
        );
      }

      return localized
        .replace(/%([0-9]+)\$[sd]/g, (m, n) => args[n - 1])
        .replace(/%[sd]/g, () => args.shift());
    }

    return localized;
  };
}

export function i18nContext(component) {
  const childContextTypes = (component.childContextTypes =
    component.childContextTypes || {});
  childContextTypes.i18n = i18nContextPropType;

  const getChildContext = component.prototype.getChildContext;
  component.prototype.getChildContext = function() {
    const childContext = getChildContext ? getChildContext.bind(this)() : {};
    return {
      ...childContext,
      i18n: this.props.i18n
    };
  };

  return component;
}

export default function i18nConnect(component) {
  component.prototype.i18n = i18n();

  const contextTypes = (component.contextTypes = component.contextTypes || {});
  contextTypes.i18n = i18nContextPropType;

  return component;
}
